import { useState } from 'react'
import PermissionsCheck from '../../../../../components/PermissionsCheck'
import { checkPermissions } from '../../../../../components/PermissionsCheck/helpers'
import { Permission } from '../../../../../graphql'
import {
	EuiButton,
	EuiModalBody,
	EuiModalFooter,
} from '@equipmentshare/ds2'
import PartForm, { PartFormState } from '../PartForm'
import usePermissions from 'hooks/usePermissions'

export type Part = {
  partId?: number,
  description?: string,
  partNumber?: string,
  provider?: {
    id: number,
    name: string,
  },
  upc?: string,
  standardPrice?: {
		amount: number,
		currencyCode: string,
	},
	msrp?: number,
	partClass: { description: string },
}

export type AddEditPartProps = {
  canMerge?: boolean,
  onMerge?: ( part: Part ) => void,
  onCancel: () => void,
  onSuccess: () => void,
  onSubmit: ( partArgs: any ) => Promise<any>,
  part?: Part,
  formData?: any,
}

export default function AddEditPart( { canMerge, onMerge, onCancel, onSubmit, onSuccess, part, formData }: AddEditPartProps ): JSX.Element {
	const [ isSaving, setIsSaving ] = useState( false )
	const [ formState, setFormState ] = useState<PartFormState>( {
		partId: undefined,
		partNumber: '',
		description: '',
		provider: undefined,
		upc: undefined,
		standardPrice: undefined,
		msrp: undefined,
		isBulk: false,
		...formData,
	} )

	const { userPermissions } = usePermissions( [ Permission.CanEditPriceList ] )

	const canEditListPrice = checkPermissions( userPermissions, [ Permission.CanEditPriceList ] )

	const isValid = formState.provider && formState.partNumber && formState.description

	const handleSubmit = async() => {
		setIsSaving( true )
		const { provider, partNumber, description, upc, standardPrice, msrp, isBulk, productClass } = formState

		try {
			await onSubmit( {
				partId: formData?.partId,
				partNumber,
				description,
				providerId: provider?.id,
				upc,
				...( canEditListPrice && standardPrice ? { standardPrice: parseFloat( standardPrice ) } : {} ),
				msrp: msrp ? parseFloat( msrp ) : undefined,
				productClassId: isBulk ? productClass?.id : null,
			} )
		  onSuccess()
		} catch ( e: unknown ) {
			setIsSaving( false )
		}
	}

	return (
		<>
			<EuiModalBody>
				<PartForm
					canEditListPrice={canEditListPrice}
					formState={formState}
					setFormState={setFormState}
				/>
			</EuiModalBody>
			<EuiModalFooter>
				{ canMerge && onMerge && part && (
					<PermissionsCheck permissionsToCheck={[ Permission.CanMergeParts ]}>
						<EuiButton
							onClick={() => onMerge( part )}
						>
							Merge products
						</EuiButton>
					</PermissionsCheck>
				) }
				<EuiButton
					id="cancelBtn"
					onClick={onCancel}
					color="text"
				>
					Cancel
				</EuiButton>
				<EuiButton
					id="submitBtn"
					fill
					isLoading={isSaving}
					isDisabled={!isValid}
					onClick={handleSubmit}
				>
					Submit
				</EuiButton>
			</EuiModalFooter>
		</>
	)
}
